<template>
  <div>
   
    <container>
      Runner's Data
      <table style="width:100%;    table-layout: fixed; height:39.3rem">
        <td style="width:25%">
          <tr></tr>
          <tr>
            <img :src="runner.imageUrl" alt="Profile" style="height: 5rem;border-radius: 50%;" />
          </tr>
          <div style="color:red;padding-top: 3rem;">
            <h1 style="font-size: large;font-family: sans-serif;">CONFIDENTIAL</h1>
            <tr>Mail address: {{runner.runner?runner.runner.user.email:null}}</tr>
            <tr>Height: {{runner.runner?runner.runner.height:null}}</tr>
            <tr>Weight: {{runner.runner?runner.runner.weight:null}}</tr>
            <tr> <button class = "edit" @click.stop.prevent="openEmailEditModal()">EDIT email</button> </tr>          
            <edit-email :runner = "runner" :show="showEmailModal" @saved="onSavedEmail"  @closed="onClosed"></edit-email> 
          </div>
          <div style="margin-top: 101px;" v-if="this.runner.runner">
            <tr>Catchphrase</tr>
            <textarea type = "text" v-model="runner.runner.catchPhrase" id="catchPhrase" maxlength="255" name="catchPhrase" Placeholder="" class="catchphrase"></textarea> &nbsp;&nbsp;<a href="javascript:void(0);" @click="addCatchPhrase()">{{hasCatchPhrase}}</a>
          </div>
        </td>
        <td style="width:35%">
          <tr>Runner ID : {{runner.runner?runner.runner.id:null}}</tr>
          <tr>Runner Name : {{runner.runner?runner.runner.firstName:null}}</tr>
          <tr>Gender: {{runner.runner?runner.runner.gender:null}}</tr>
          <tr>Location: {{runner.runner?runner.runner.lastName:null}}</tr>
          <tr>URL:
            <a :href="runner.runner?runner.runner.website:null" target="_blank">{{runner.runner?runner.runner.website:null}}</a>
          </tr>
          <tr>Profile: {{profileTexts}}
          </tr>
          <tr>Total km: {{runner.totalDistance}}</tr>
          <tr>Last Run: -</tr>
          <tr>Days since last Run: {{runner.daysSinceLastClass}}</tr>
          <tr>Last 30 days Best Rank: {{runner.bestPlaceCurrentMonth}}</tr>
          <tr>Number of completed sessions: {{runner.totalRuns}}</tr>

          <tr> Gold {{Gold}}  &nbsp;&nbsp; 
               Silver {{Silver}}  &nbsp;&nbsp; 
               Bronze {{Bronze}}</tr>
          <tr>Account created on: {{createdOn}}</tr>


         
          <tr>ラン・ウォーク : {{runner.totalRuns}}</tr>
          <tr>筋トレ : {{runner.totalCountIndoorTraining}}</tr>
          <tr>ストレッチ : {{runner.totalCountStretch}}</tr>
          <tr>ヨガ : {{runner.totalCountYoga}}</tr>
          <br>      

          <tr style="height:65px;margin-top:10px">Memo &nbsp;&nbsp;&nbsp;&nbsp;<textarea type = "text" v-model="memo" id="memo" maxlength="255" name="memo" Placeholder="" class="memo"></textarea> &nbsp;&nbsp;<a href="javascript:void(0);" @click="addMemo(runner.runner.id)">{{hasMemo}}</a></tr>
          <tr class="runner-tags">
            
           
            <p style="float: left;padding-top: 10px;">Tags</p>
             <selectize v-bind:options="options" v-model="selected" multiple size="1"
                :runnerid="this.$props.runnerId" :isRunnerTag='true'
                data-dropdown-parent="body" data-max-options="100"
                data-value-field= 'id' data-label-field='name' 
                data-search-field= 'name' data-sort-field= 'name'
                style="visibility:hidden">
            </selectize>
          </tr>

           <tr class="promocode-tags">        
            <p style="float: left;padding-top: 10px;">Promo Code Tags</p>
             <selectize v-bind:options="options" v-model="selectedPromoTags" multiple size="1"
                :runnerid="this.$props.runnerId" :isPromoCodeTag='true'
                data-dropdown-parent="body" data-max-options="100"
                data-value-field= 'id' data-label-field='name' 
                data-search-field= 'name' data-sort-field= 'name'
                style="visibility:hidden">
            </selectize>
          </tr>
        </td>

        <td style="width:40%">

          <table class="best">
           <div>
            <td style="padding: 0px 7px 0 7px;">
              <tr class="topTr">
              </tr>
              
              <tr style="color: rgb(60, 55, 185);" class="trh" >
               <span style="line-height: 25px;"> 20 min </span>
              </tr>
              <hr>
              <br/>
              <tr  style="color: rgb(60, 55, 185);" class="trh">
               <span style="line-height: 25px;"> 30 min </span>
              </tr>
              <hr><br/>
              <tr  style="color: rgb(60, 55, 185);" class="trh">
               <span style="line-height: 25px;"> 40 min </span>
              </tr>
              <hr><br/>
              <tr  style="color: rgb(60, 55, 185);" class="trh">
                <span style="line-height: 25px;"> 60 min </span>
              </tr>

            </td>
            <td style="padding: 0px 20px 0 20px;">
              <tr style="text-align: left;" class="topTr">Best {{currentYear}}</tr>
              <tr class="trh">
                <span v-if="currentYearbest[20]" v-for="best in currentYearbest[20] " style="line-height: 25px;">
                    <span>{{date(convertToLocal(best.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(best.distance/1000).toFixed(2)}}km</span> <br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh" >
                <span v-if="currentYearbest[30]" v-for="best in currentYearbest[30] " style="line-height: 25px;">
                    <span>{{date(convertToLocal(best.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(best.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh">
                <span v-if="currentYearbest[40]" v-for="best in currentYearbest[40] " style="line-height: 25px;">
                <span>{{date(convertToLocal(best.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(best.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh">
                <span v-if="currentYearbest[60]" v-for="best in currentYearbest[60] " style="line-height: 25px;">
                <span>{{date(convertToLocal(best.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(best.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>

            </td>
            
            <td style="background-color: #c3c5cc;border-radius: 10px; padding: 0 15px 0 15px;">
              
                <tr class="topTr" style="text-align: center; font-weight: bold;">All time</tr>
                 <tr class="trh">
                <span v-if="best[20]" v-for="bestrec in best[20] " style="line-height: 25px;">
                    <span>{{date(convertToLocal(bestrec.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(bestrec.distance/1000).toFixed(2)}}km</span> <br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh" >
                <span v-if="best[30]" v-for="bestrec in best[30] " style="line-height: 25px;">
                    <span>{{date(convertToLocal(bestrec.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(bestrec.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh">
                <span v-if="best[40]" v-for="bestrec in best[40] " style="line-height: 25px;">
                <span>{{date(convertToLocal(bestrec.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(bestrec.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>
              <hr><br/>
              <tr class="trh">
                <span v-if="best[60]" v-for="bestrec in best[60] " style="line-height: 25px;">
                <span>{{date(convertToLocal(bestrec.raceResume.finishDate))}}</span>
                    <span style="padding-left:2rem"> {{(bestrec.distance/1000).toFixed(2)}}km</span><br/>
                </span>
              </tr>
              
            </td>
            
           </div>
          </table>
        <tr></tr>
 
        <tr style="height:50px">CM Memo &nbsp;&nbsp;<textarea type = "text" v-model="cmmemo" id="cmmemo" maxlength="2000" name="cmmemo" Placeholder="" class="cmmemo"></textarea> &nbsp;&nbsp;<a href="javascript:void(0);" @click="addCMMemo(runner.runner.id)">{{hasCMMemo}}</a></tr>
       
        </td>

      </table>

     

      <div  v-if = "this.$route.query.runmetrix == 1">
        <run-metrix v-if = "this.$route.query.runmetrix == 1" :runmetrix="runmetrixData" :runnerId="this.$props.runnerId"></run-metrix>
      </div>


      <div v-else>
        <div>
        <!-- <button @click=getRunnersData(runner.id)>Runmetrix</button> -->
          <router-link :to="{ name: 'runner-data',
                params: {runnerId: this.$props.runnerId},
                query: {runmetrix:1 }}"
            target="_blank" class="runmetrix_btn">
              Runmetrix
          </router-link>
        </div>
      <div class="add_race">
         <img src="../../../assets/add-race.png" alt="Add Race" style="cursor: pointer;" @click="addRace()"><span >Add a race</span>              
      </div>

      <div style=" padding-left:2rem; padding-top:1px">  履歴 Past Runs</div>
         <v-table         
               is-horizontal-resize
              :vertical-resize-offset='60'       
              :multiple-sort="false"
              :is-loading="isLoading"
              style="width:100%;font-size:10.5px"
              even-bg-color="#f2f2f2"
              :column-cell-class-name="columnCellClass"
              :columns="tableConfig.columns"
              :table-data="tableConfig.tableData"
              :paging-index="(pageIndex-1)*pageSize"
              @on-custom-comp="customCompFunc">
          </v-table>
        <div class="mt20 mb20 bold">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
       </div>

           <edit-distance :race = "raceData" :show="showModal" @saved="onSaved"  @closed="onClosed"></edit-distance> 
           <add-race-data :race = "raceData" :runnerId="this.$props.runnerId"  :show="showAddRaceModal" @saved="onSavedRace"  @closed="onClosed"></add-race-data> 
   
      </div>   

      

    </container>
  </div>
</template>

<script>
let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }


  import Container from '@/components/Container'
  import { SweetModal} from 'sweet-modal-vue'
  import EditDistance from './EditDistance'
  import EditEmail from './EditEmail'
  import Selectize from '@/components/Selectize'
  import AddRaceData from './AddRaceData'
  import RunMetrix from './RunMetrix'
  import 'vue-easytable/libs/themes-base/index.css'
  import {VTable,VPagination} from 'vue-easytable'
  import VuejsDialog from "vuejs-dialog"
  import Vue from "vue"
  import moment from 'moment'           
  import {
    mapGetters
  } from 'vuex'
   import {
    db
  } from '../../../firebase'
  Vue.component(VTable.name, VTable)
  Vue.component(VPagination.name, VPagination)
  import RunnersByRaceService from '../../../services/runnersByRace'
  import RunnersService from '../../../services/runner'
  import RaceQuestionService from '../../../services/raceQuestion'
  import TagService from '../../../services/tag'


  export default {
    name: 'runner-data',
    props: ['runnerId', 'raceId'],
    computed: {
      ...mapGetters({
        race: 'Race/race'
      })
    },
    data: () => ({
      //options: [{ "id": 1, "text": "Hello" }, { "id": 2, "text": "World" }, { "id": 3, "text": "opt 3" }, { "id": 4, "text": "opt 4" }, { "id": 5, "text": "opt 5" }, { "id": 6, "text": "opt 6" }, { "id": 7, "text": "opt 7" }, { "id": 8, "text": "opt 8" }],
      options: [],
      selected: [],
      runner: {},
      runnerData:{},
      isLoading: true,
      raceData :{},
      showModal: false,
      showAddRaceModal:false,
      showEmailModal: false,
      profileTexts:'',
      best: {},
      currentYearbest:{},
      AllTimebest:{},
      pastRaces: [],
      totalpastRuns:[],
      pageIndex:0,
      pageTotal:100,
      pageSize:30,
      memo:'',
      cmmemo:'',
      hasMemo: 'Add',
      hasCMMemo:'Add',
      hasCatchPhrase:'Add',
      Gold:0,
      Silver:0,
      Bronze:0,
      currentYear:'',
      createdOn:null,
      promoCodeList:[],
      selectedPromoTags:[],
      runmetrixData:{},
      tableConfig: {
                    multipleSort: false,
                    tableData: [],
                   columns:  [
                              {field: "finishDate", title:'Date',  width: 70, titleAlign: 'center',columnAlign:'center',isFrozen: true},
                              {field: "duration", title:'Duration',  width: 60, titleAlign: 'center',columnAlign:'center',isFrozen: true},
                              {field: "", title:'Map', width: 60, titleAlign: 'center',columnAlign:'center',componentName:'map-route',isFrozen: true},
                              {field: "name", title:'Name', width: 200, titleAlign: 'center',columnAlign:'center',isFrozen: true,
                              formatter: function (rowData,rowIndex,pagingIndex,field) {
                                return '<a class="race_name" href="#/admin/past-run/detail/'+rowData.id+'" target="_blank"><div>'+rowData.name+'</div></a>'
                                }
                              },    
                              {field: "trainer", title:'Trainer Name', width: 100, titleAlign: 'center',columnAlign:'center',isFrozen: true},                          
                              {field: "distance",  title:'Distance', width: 60, titleAlign: 'center',columnAlign:'center',componentName:'edit-operation',isFrozen: true},
                              {field: "place", title:'Position', width: 80, titleAlign: 'center',columnAlign:'center',isFrozen: true},
                              {field: 'custome-adv',width: 100, title: 'Operation', titleAlign: 'center',columnAlign:'center',
                                 componentName:'race-operation',isFrozen: true},
                              {field: "question", title:'Question', width: 300, titleAlign: 'center',columnAlign:'center',isResize:true},
                              {field: "answer", title:'Answer',  width: 1200, titleAlign: 'left',columnAlign:'left',isResize:true, formatter: function (rowData,rowIndex,pagingIndex,field) {
                                return '<div style = "width:100%">'+rowData.answer+'<br/><hr style ="margin-bottom: 4px;margin-top: 4px;"><span style = "color:red">'+rowData.postanswer+'</span></div>'
                                }
                              }, 
                              // {field: "answer", title:'Answer',  width: 500, titleAlign: 'left',columnAlign:'left', formatter: function (rowData,rowIndex,pagingIndex,field) {
                              //   return '<div style = "width:493px">'+rowData.answer+'<br/><hr style ="margin-bottom: 4px;margin-top: 4px;"><span style = "color:red">'+rowData.postanswer+'</span></div>'
                              //   }
                              // },                          


                            ]
                }
     
    }),
    methods: {
      initialize() {},
      async addRace(){
        // var raceInFb = await db.ref(`/${this.$fbDbEntry}/7445`).once('value')
        // raceInFb.val().raceResumeId 
        console.log("innnn---add race-")
        this.showAddRaceModal = true
      },
      onSavedRace(){
        this.showAddRaceModal = false
        this.pastRaces = []
        this.getPastRuns(this.pageIndex, this.pageSize) 
        this.getTableData() 
        this.getRunnerInfo()
      },
      deleteRace(){
        console.log("innnn---delete race-",)
      },
      openEmailEditModal(){
        this.showEmailModal = true
      },
      addMemo (runnerId) {
         var data = {
           runnerId: runnerId,
           memo: {
                  memo: this.memo
           }
         }
         RunnersByRaceService.saveMemo(data).then((response) => {
            this.hasMemo = 'Edit'
         })
      },
      addCMMemo(runnerId){
         var data = {
           runnerId: runnerId,
           cmmemo: {
                  cmmemo: this.cmmemo
           }
         }
         RunnersByRaceService.saveCmMemo(data).then((response) => {
          this.hasCMMemo = 'Edit'
          })
      },
      onClosed(){
         this.showModal = false
         this.showEmailModal = false
         this.showAddRaceModal=false
      },
      onSaved(race){
         var foundIndex = this.pastRaces.findIndex(x => x.id == race.raceId)
         this.pastRaces[foundIndex].distance = (race.distance).toFixed(2) +' km'
         this.showModal = false
         
         this.getRunnerInfo()
         this.getTableData()
      },
      onSavedEmail(){
          this.showEmailModal = false
          this.getRunnerInfo()
      },
      customCompFunc(params){
        console.log("params----",params)
        // this.showModal = true
        // params.rowData['runnerId'] = this.$props.runnerId
        // this.raceData = params.rowData  

        if(params.columeName=="editDistance"){
          console.log("editDistance")
          this.showModal = true
          params.rowData['runnerId'] = this.$props.runnerId
          this.raceData = params.rowData  
        }else if(params.columeName=="deleteRace")    {
          console.log("deleteRace")
          this.$dialog.confirm("Are you sure you want to delete this run？", dialogOptions)
            .then((dialog) => {
                RunnersByRaceService.deleteRaceResume(params.rowData.runnerRaceResume.id).then((response) => {              
                  console.log("done",response)
                  this.$delete(this.tableConfig.tableData,params.index)
                })
            })
        }
        //else if(params.columeName=="addRace"){
        //   console.log("addRace")          
        //   params.rowData['runnerId'] = this.$props.runnerId
        //   this.raceData = params.rowData
        //   this.showAddRaceModal = true
          
        // }         
      },
      date(date) {
       return moment.utc(date).format('YYYY/MM/DD')
      },

      convertToLocal(date){
        var fdate = new Date(date)
        return fdate.toDateString()
      },
      getTableData(){
        console.log("this.pastRaces--->>>",this.pastRaces)
          this.tableConfig.tableData = this.pastRaces
          //this.pageTotal = this.totalpastRuns.length
      },
      pageChange(pageIndex){
      
            this.pageIndex = pageIndex-1
            this.pastRaces = []
            this.getTableData()
            this.getPastRuns(pageIndex, this.pageSize)
          
      },
      pageSizeChange(pageSize){

          this.pageIndex = 0
          this.pageSize = pageSize
          this.pastRaces = []
          this.getTableData()
          this.getPastRuns(this.pageIndex, pageSize)
          
      },
      unicodeToChar(text) {
        return text.replace(/\\u[\dA-F]{4}/gi, 
                function (match) {
                    return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
                })
      },

      columnCellClass(rowIndex,columnName,rowData){
      
            if(columnName==='answer'){
                  return 'column-cell-class-name-test1'
            } 
            if(columnName==='distance'){
                  return 'column-cell-class-name-test2'
            }
      },

       getRunnerInfo() {
          RunnersByRaceService.getByRunnerId(this.$props.runnerId).then(async (response)=>{
          this.runner = response.data
          let user = await RunnersByRaceService.getUserInfo(response.data.runner.user.login)
          this.createdOn= moment(user.data.createdDate).format('L')

          this.runmetrixData = this.runner.runner.runmetrix

          console.log(" this.runner-********--", this.runmetrixData)
         
          console.log(" this.runner---", this.runner)
          this.getPromoCodeTags(this.runner)
         
          if(this.runner.totalSubscribedSessions != undefined){
            this.pageTotal = this.runner.totalSubscribedSessions
          }else{
            this.getSubscribedRaces()
          }
          if(this.runner.runner.catchPhrase === null || this.runner.runner.catchPhrase == undefined){
            this.hasCatchPhrase = 'Add'      
          }else{
            this.hasCatchPhrase = 'Edit'
          }
          if(this.runner.runnerMemo === null){
              this.hasMemo = 'Add'      
          }else{
            this.hasMemo = 'Edit'
            this.memo = this.runner.runnerMemo.memo
          }

          if(this.runner.runnerCMMemo === null){
              this.hasCMMemo = 'Add'      
          }else{
            this.hasCMMemo = 'Edit'
            this.cmmemo = this.runner.runnerCMMemo.cmmemo
          }
          this.profileTexts = this.unicodeToChar(response.data.runner.profileText)      
        })
        //Get All Time Best Records
        RunnersByRaceService.getBestDuration(this.$props.runnerId).then((response) => {
          this.best = response.data
          //Show only one best record in ALL TIME
          let obj = {}
             for (var key in this.best) {
              if (this.best.hasOwnProperty(key)) {
                  //  this.best[key]
                   let maxDistance
                  if(this.best[key].length>0){
                    maxDistance =  this.best[key].reduce((a, b) => a.distance > b.distance ? a : b)
                  }
                        obj[key] = maxDistance
              }
          }         
           this.AllTimebest = obj
        })

        //Get 2019 Best Records
        var d = new Date()
        this.currentYear = d.getFullYear()
        RunnersByRaceService.getCurrentYearBestDuration(this.$props.runnerId, this.currentYear).then((response) => {
          // let Yearbest = response.data
          // let obj = {}
          // for (var key in Yearbest) {
          //     if (Yearbest.hasOwnProperty(key)) {
          //          Yearbest[key]
          //          let maxDistance
          //           if(Yearbest[key].length>0){
          //               maxDistance =  Yearbest[key].reduce((a, b) => a.distance > b.distance ? a : b)
          //           }
                     
          //         obj[key] = maxDistance
          //     }
          // }
          this.currentYearbest = response.data
        })

        RunnersByRaceService.getRunnerMedals(this.$props.runnerId).then((response) => {
          response.data.forEach(medal => {
            if(medal.medal.badge === 'Gold'){
              this.Gold = medal.count
            }
            if(medal.medal.badge === 'Silver'){
              this.Silver = medal.count
            }
            if(medal.medal.badge === 'Bronze'){
              this.Bronze = medal.count
            }           
          })
        })
      },

      getPromoCodeTags(runner){
        //Get promocode tags list
        if(runner.runner && runner.runner.memberShip!=undefined &&
          runner.runner.memberShip.promoCodeList !=undefined ){
          this.promoCodeList = runner.runner.memberShip.promoCodeList //Get all promocodes of runner
          console.log("promoCodeList>>",this.promoCodeList)

          // let arr = this.promoCodeList.map(({ tags }) => tags)
          var promoCodeTags = this.promoCodeList.map(({ tags }) => tags[0] ) //Get tags of promocode
          promoCodeTags = promoCodeTags.filter((tags)=>tags != undefined) //remove undefined tags
          this.selectedPromoTags = promoCodeTags.map(a => a.id) //Get tag ids
        }
      },

      getPastRuns(index, pageSize){
          var data = { page: index-1, runnerId: this.$props.runnerId, size: pageSize ,sort:"finishDate,desc"} 
          this.isLoading = true
          RunnersByRaceService.getRunnerPastRuns(data).then((response)=>{
          this.isLoading = false
          //console.log("response--",response.data)
               response.data.forEach(race => {

                 //Position
                 var pos = race.runnerRaceResume.runnerPlace
                 var people = race.runnerRaceResume.raceResume.totalAmountRunners
                 var place =pos +'位'+ people + '人中'
                 race['place'] = place
                 //Date
                  // var fdate = new Date(race.runnerRaceResume.raceResume.finishDate)
                   var fdate = new Date(race.runnerRaceResume.finishDate)
                      fdate = fdate.toDateString()
                  race['finishDate'] = this.date(fdate)
                 //Duration
                 race['duration'] = race.runnerRaceResume.raceResume.race.duration+'分'
                  //Id
                 race['id'] = race.runnerRaceResume.raceResume.race.id
                 //Name
                 race['trainer'] = race.runnerRaceResume.raceResume.race.trainer.firstName 
                 race['name'] = race.runnerRaceResume.raceResume.race.name
                 //Distance
                 race['distance'] = race.runnerRaceResume.distanceLabel
                 //Question
                 race['question'] = race.questionAnswer?race.questionAnswer.raceQuestion.question:'-'
                 //PreAnswer
                 race['answer'] = race.questionAnswer?race.questionAnswer.answer:'-'

                 //PostAnswer
                RaceQuestionService.getRunnerPostAnswer(race.runnerRaceResume.raceResume.race.id,this.$props.runnerId)
                .then((response)=>{        
                  var postAnswer = response.body?response.body.answer:'-'
                    if(postAnswer != undefined){
                      race['postanswer'] = postAnswer
                    }           
                })
                 race['postanswer'] = '-'
                this.pastRaces.push(race)
               })
          })
      },
      getAllTags(){
         TagService.getAllTags().then((response)=>{
            this.options = response.data     
            this.getRunnerTags()
         })
      },

      getRunnerTags(){        
        TagService.getRunnerTags(this.$props.runnerId).then((response)=>{
          //console.log("this.options---",this.options.map(a => a.id))
            this.selected = response.data.map(a => a.id)
         })
      },
      getSubscribedRaces(){
        RunnersByRaceService.getSubscribedRaces(this.$props.runnerId).then((response)=>{
          this.totalpastRuns = response.data   
          this.pageTotal = this.totalpastRuns.length
        })
      },
      addCatchPhrase(){
        RunnersService.update(this.runner.runner).then((response)=>{
           console.log("Update CatchPhrase>",response.data)
           this.hasCatchPhrase = 'Edit'
        })
      },
      getRunnersData(id){
          let route = this.$router.resolve({
                    // path: '/runner/:runnerId?runmetrix == 1',
                    name: 'runner-data',
                    params: {
                          runnerId: this.$props.runnerId
                    },           
                    query: {
                      runmetrix:1
                    }                      
          })
          console.log(">>>>>>",route)
          window.open(route.href, '_blank')
      },
    },
    created() {
      this.getRunnerInfo()  
      this.getAllTags()
      //this.getRunnerTags()
     
      // RunnersByRaceService.getSubscribedRaces(this.$props.runnerId).then((response)=>{
      //   this.totalpastRuns = response.data   
      //   this.getPastRuns(this.pageIndex, this.pageSize) 
      //   this.getTableData()     
      // })

      this.getPastRuns(this.pageIndex, this.pageSize) 
      this.getTableData()    

    },
    components: {
      Container,
      SweetModal,
      EditDistance,
      EditEmail,
      AddRaceData,
      Selectize,
      RunMetrix
    }
  }

  Vue.component('edit-operation',{
        template:`
        <span>              
             <div>{{rowData.distance}}</div>                   
             <button class = "edit" @click.stop.prevent="openEditModal()">Edit</button>  
        </span>   
           `,
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          openEditModal(){
             let params = {columeName:"editDistance",rowData:this.rowData}
              this.$emit('on-custom-comp',params)
          }
        },
        created() { 
        //   this.id =   this.rowData.id
        }
  })
Vue.component('map-route',{
        template:`
        <span>                                 
          <button class="edit" @click.stop.prevent="openEditModal()">Map</button>  
        </span>   
           `,
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          openEditModal(){
              let route = this.$router.resolve({
                    name: 'google-map',
                    params: {
                          raceId: this.rowData.id,
                          runnerId: this.rowData.runnerRaceResume.runner.id
                        }
                    })
              window.open(route.href, '_blank')
          }
        },
        created() { 
        //   this.id =   this.rowData.id
        }
  })








        
  Vue.component('race-operation',{
        template:` <div class="race_operation">

        <!-- <label class="add_race">
           <button id="addRace" @click.stop.prevent="addRace()">
           </button>
           <span style="margin-right: 35px;">Add</span>
         </label>
        -->
       <label class="delete_race">
          <button id="deleteRace" @click.stop.prevent="deleteRace()">
          </button>
          <span>Delete</span>
        </label>      


       </div>
      `,
        data: () => ({
          path: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          deleteRace(){
            console.log("innnnnnnnnn",this.rowData.runnerRaceResume.id)
             let params = {columeName:"deleteRace",rowData:this.rowData,index:this.index}
              this.$emit('on-custom-comp',params)
          },
           addRace(){
            console.log("in addRace",this.rowData.runnerRaceResume.id)
             let params = {columeName:"addRace",rowData:this.rowData,index:this.index}
              this.$emit('on-custom-comp',params)
          }
        },
        created () {
          //this.mountPath()
        },

    })
</script>

<style>
tr {
  height: 25px;
  word-break: break-all;
}

.trh {
  height: 75px;
}
.topTr {
  height: 32px;
}

th {
  color: blue;
  text-align: initial;
}

.best {
  width: 100%;
  /* height: 150px; */
  margin: 0px auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: gainsboro;
  box-shadow: 5px 5px 5px -1px rgba(0, 0, 0, 0.19);
}

td {
  overflow: hidden;
}

.column-cell-class-name-test1 .v-table-body-cell {
  line-height: 10px !important;
  white-space: nowrap !important;
  word-wrap: normal !important;
  vertical-align: middle;
  display: table-cell;
  height: 80px;
}
.column-cell-class-name-test2 .v-table-body-cell {
  line-height: 20px !important;
}
.edit {
  background: red;
  padding: 0px 12px 0px 12px;
  color: white;
  border-radius: 10px;
  border-width: 1px;
  font-weight: bold;
}

.memo {
  height: 50px;
  /* width: 350px; */
  width:300px;
  border-radius: 6px;
  padding: 4px;
  margin-bottom: -20px;
}

.cmmemo {
  height: 99px;
  width: 350px;
  border-radius: 6px;
  padding: 7px;
  margin-bottom: -40px;
}

.catchphrase{
  height: 100px;
  width: 224px;
  border-radius: 6px;
  padding: 4px;
  margin-bottom: -20px;
}

.add_race span {
  margin: 0 12px 0 8px;
  position: relative;
  top: -6px;
}
.add_race {
  text-align: right;
  padding-top: 2rem;
}

#addRace {
  width: 30px;
  height: 30px;
  background-image: url(../../../assets/add-race.png);
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
}
.race_operation .add_race button#addRace {
  float: left;
}

.race_operation .add_race {
  padding: 0;
  display: inline-block;
}

.race_operation .delete_race button#addRace {
      position: relative;
    top: 9px;
}
.race_operation #deleteRace {
  position: relative;
  top: 9px;
}
.race_operation .delete_race {
  padding: 0;
  display: inline-block;
  /* width: 50%; */
}
.race_operation #deleteRace span {
  float: right;
}
label.delete_race span {
  position: relative;
  top: -5px;
}

#deleteRace {
  width: 30px;
  height: 30px;
  background-image: url(../../../assets/delete-race.png);
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
}

.runner-tags .selectize-control.multi .selectize-input>div.active {
  background: #efefef;
  color: #000;
  border: 0 solid transparent;
}
.runner-tags .selectize-control.multi .selectize-input>div{
  color: #000;
  margin: 0 10px 3px 0;
}
.runner-tags .selectize-control{
  float: right;
  width: 87%;
  margin-bottom: 10px;
}

.promocode-tags .selectize-control.multi .selectize-input>div.active {
  background: #efefef;
  color: #000;
  border: 0 solid transparent;
}
.promocode-tags .selectize-control.multi .selectize-input>div{
  color: #000;
  margin: 0 10px 3px 0;
}
.promocode-tags .selectize-control{
  float: right;
  width: 70%;
}

a.race_name{
  color:black;
}
a:hover.race_name{
  color:#108ee9;
}

.runmetrix_btn
{
    border: 1px solid #cccccc;
    padding: 6px 10px;
    border-radius: 20px;
    color: black;
}

</style>


// WEBPACK FOOTER //
// RunnerData.vue?53f05630